$(document).ready(function () {
    
    $('body').on('click touch', '.js-open-popup', function() {
        var popup_id = $(this).attr('data-popup');       
        $('.'+popup_id).fadeIn(300);        

        $('body').on('click touch', '.'+popup_id+' .btn_close', function() {
            $('.'+popup_id).fadeOut(300);
        });

        $('body').on('click', '.popup_container', function(e) {
            $('.'+popup_id).fadeOut(300);
        });

        $('body').on('click', '.popup_content', function(e){ 
            e.stopPropagation(); 
        }); 
        
    });

});